const REACT_SCAN_CDN = "https://unpkg.com/react-scan@0.5.7/dist/auto.global.js"

declare global {
  interface Window {
    reactScan?: (options?: { enabled?: boolean; showToolbar?: boolean }) => void
  }
}

function waitForScript(script: HTMLScriptElement): Promise<void> {
  if (window.reactScan) {
    return Promise.resolve()
  }

  return new Promise((resolve, reject) => {
    const finish = () => resolve()

    script.addEventListener("load", finish, { once: true })
    script.addEventListener(
      "error",
      () => reject(new Error("Failed to load react-scan from CDN")),
      { once: true },
    )

    // Handle cache hits where the script executes before listeners attach.
    queueMicrotask(() => {
      if (window.reactScan) {
        finish()
      }
    })
  })
}

function isReactScanEnabled(): boolean {
  if (!import.meta.env.DEV) {
    return false
  }

  const flag = import.meta.env.VITE_WITH_REACT_SCAN
  return flag === "true" || flag === "True" || flag === "1"
}

export async function loadReactScan(): Promise<void> {
  if (!isReactScanEnabled()) {
    return
  }

  const existing = document.querySelector<HTMLScriptElement>(
    "script[data-react-scan]",
  )

  if (existing) {
    await waitForScript(existing)
  } else {
    const script = document.createElement("script")
    script.dataset.reactScan = "true"
    script.crossOrigin = "anonymous"
    script.src = REACT_SCAN_CDN
    document.head.prepend(script)
    await waitForScript(script)
  }

  window.reactScan?.({
    enabled: true,
    showToolbar: true,
  })
}
